var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 114,
    viewBox: "0 0 184 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8853 0.227173H183.502V63.8095H86.8853V0.227173ZM120.098 28.9989C120.098 34.0109 116.052 38.0568 111.04 38.0568H105.001V50.1339H95.9436V13.9025H111.04C116.052 13.9025 120.098 17.9483 120.098 22.9603V28.9989ZM141.233 50.1339C146.245 50.1339 150.291 46.0881 150.291 41.0761V22.9603C150.291 17.9483 146.245 13.9024 141.233 13.9024H126.136V50.1339H141.233ZM174.446 22.9603H165.388V28.9989H174.446V38.0568H165.388V50.1339H156.33V13.9024H174.446V22.9603ZM111.04 28.9987H105.001V22.9602H111.04V28.9987ZM135.194 41.0759H141.233V22.9602H135.194V41.0759ZM36.747 63.8215H0.93457V20.8466H36.747V63.8215ZM36.747 113.959H0.93457V70.9843H36.747V113.959ZM43.9095 113.959H79.722V70.9843H43.9095V113.959ZM122.697 113.959H86.8844V70.9843H122.697V113.959ZM43.9095 63.8215H79.722V20.8466H43.9095V63.8215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfGeneration);
export default __webpack_public_path__ + "static/media/pdf-generation.d3db877f635e892134b2a7bf02ff075a.svg";
export { ForwardRef as ReactComponent };